<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/app.component.html